(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petro-collection-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-petro-cgrid]').forEach(function (root) {
    var form = root.querySelector('[data-petro-filter-form]');
    if (form) {
      var timer;
      form.addEventListener('change', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          form.submit();
        }, 350);
      });
    }

    var grid = root.querySelector('[data-petro-grid]');
    var buttons = root.querySelectorAll('[data-view-btn]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (grid) grid.setAttribute('data-view', btn.dataset.viewBtn);
        buttons.forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petro-product-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.petroBuyReady) return;
      root.dataset.petroBuyReady = 'true';

      const price = root.querySelector('[data-petro-price]');
      const sku = root.querySelector('[data-petro-sku]');
      root.addEventListener('change', (event) => {
        if (!event.target.matches('input[name="id"]')) return;
        if (price) price.textContent = event.target.dataset.price;
        if (sku) {
          const value = event.target.dataset.sku || '';
          sku.hidden = !value;
          sku.querySelector('[data-petro-sku-value]').textContent = value;
        }
      });

      const buyForm = root.querySelector('.petro-product-hero__buy-form');
      if (buyForm && window.petroCart) {
        buyForm.addEventListener('submit', (event) => {
          event.preventDefault();
          const btn = buyForm.querySelector('[type="submit"]');
          if (btn.disabled) return;
          btn.disabled = true;
          btn.style.opacity = '0.6';
          window.petroCart.add(new FormData(buyForm))
            .catch((err) => { window.alert(err.message); })
            .finally(() => { btn.disabled = false; btn.style.opacity = ''; });
        });
      }

      const stepper = root.querySelector('[data-petro-stepper]');
      if (stepper) {
        const input = stepper.querySelector('input');
        stepper.addEventListener('click', (event) => {
          const button = event.target.closest('[data-step]');
          if (!button) return;
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(button.dataset.step));
        });
      }
    };
    const run = () => document.querySelectorAll('[data-petro-buy]').forEach(init);
    run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petro-product-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('petro-carousel[data-related-url]').forEach(async (carousel) => {
    const track = carousel.querySelector('[data-petro-carousel-track]');
    if (!track || track.children.length) return;
    try {
      const response = await fetch(carousel.dataset.relatedUrl);
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const items = doc.querySelector('[data-petro-carousel-track]');
      if (!items || !items.children.length) return;
      track.innerHTML = items.innerHTML;
      carousel.hidden = false;
      carousel.update?.();
    } catch (error) {
      /* leave the section hidden */
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petro-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.petroTabsReady) return;
      root.dataset.petroTabsReady = 'true';
      const tabs = Array.from(root.querySelectorAll('[role="tab"]'));

      const select = (tab, focus) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      };

      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', (e) => {
          const keys = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 };
          if (!(e.key in keys)) return;
          e.preventDefault();
          select(tabs[(keys[e.key] + tabs.length) % tabs.length], true);
        });
      });
    };

    const run = () => document.querySelectorAll('[data-petro-tabs]').forEach(init);
    run();
    document.addEventListener('shopify:section:load', run);

    // Theme editor: selecting a Tab block, or a card inside a tab, shows that tab in the preview
    document.addEventListener('shopify:block:select', (event) => {
      const target = event.target;
      if (!target || !target.closest) return;
      let tab = target.matches('[data-petro-tabs] [role="tab"]') ? target : null;
      if (!tab) {
        const panel = target.closest('[role="tabpanel"]');
        if (panel) tab = document.querySelector('[aria-controls="' + panel.id + '"]');
      }
      if (tab) tab.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petro-video-feature"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var play = event.target.closest('[data-petro-video-src]');
    if (play) {
      var root = play.closest('.petro-video');
      var dialog = root && root.querySelector('.petro-video__dialog');
      if (!dialog) return;
      var frame = dialog.querySelector('.petro-video__frame');
      frame.innerHTML = '<iframe src="' + play.getAttribute('data-petro-video-src') + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen title="Video"></iframe>';
      if (typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }
    var close = event.target.closest('.petro-video__close');
    var dlg = event.target.classList && event.target.classList.contains('petro-video__dialog') ? event.target : null;
    var target = close ? close.closest('dialog') : dlg;
    if (target) target.close();
  });

  document.addEventListener(
    'close',
    function (event) {
      if (event.target.classList && event.target.classList.contains('petro-video__dialog')) {
        event.target.querySelector('.petro-video__frame').innerHTML = '';
      }
    },
    true
  );

  } catch(e) { console.error(e); }
})();
})();
